import MeasurementReport from "./MeasurementReport.js";
import Polyline from "./Polyline.js";
import Polygon from "./Polygon.js";
import Point from "./Point.js";
import Circle from "./Circle.js";
import Ellipse from "./Ellipse.js";

const DICOMMicroscopyViewer = {
    Polyline,
    Polygon,
    Point,
    Circle,
    Ellipse,
    MeasurementReport
};

export default DICOMMicroscopyViewer;
